import styles from "../styles/profile.module.scss";
import Button from "../../../components/shared/Button/Button";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import { useDispatch } from "react-redux";
import { setOpenModal } from "../../../store/slices/modals.slice";
import { useAppSelector } from "../../../store/store";
import useAnotherGaEvents from "../../../utils/hooks/useAnotherGaEvents";

interface IProps {
  id: number;
  amount: string;
  total: number;
  price: number;
  discount: string;
  priceUpToDate: boolean;
  subscribe: (id: number) => void;
  isActiveFlag: boolean;
}
const SubscriptionCard = ({ id, amount, total, price, discount, priceUpToDate, subscribe, isActiveFlag }: IProps) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { trackMonthlyPurchase, trackYearlyPurchase } = useAnotherGaEvents();
  const userData = useAppSelector((state: any) => state.auth.userData);

  const dirData = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div className={styles.subscriptionCardWrapper}>
      <div className={styles.cardBlock}>
        <div className={styles.cardHolder}>
          <div className={styles.cartAmountWrapper}>
            {discount && (
              <div dir={dirData} className={styles.discount}>
                {t("shortDiscount")} {discount}
              </div>
            )}
            <div className={styles.amount}>{amount}</div>
          </div>
          <div className={styles.total}>
            {priceUpToDate ? total : "..."} {t("perMth")}
          </div>
        </div>
        <div className={styles.cardRightContent}>
          <div className={`${styles.priceWrapper} ${isActiveFlag && styles.priceWrapperActive}`}>
            {!isActiveFlag ? (
              <div className={styles.price}>
                {priceUpToDate ? price : "..."}
                <span> $</span>
              </div>
            ) : (
              <div className={styles.priceActive}>{t("active")}</div>
            )}

            {!isActiveFlag && (
              <div className={styles.buttonsWrapper}>
                <Button
                  className={styles.connectButton}
                  title={t("subscribe")}
                  submit={() => {
                    if (id !== 0 && userData.is_subscribed && userData.product_id !== id) {
                      dispatch(setOpenModal("changeSub"));
                    }
                    if (id === 1) {
                      trackMonthlyPurchase(price);
                    } else {
                      trackYearlyPurchase(price);
                    }
                    subscribe(id);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <Link to={ROUTES.DISCOUNT} className={styles.cardLink}>
        {t("subDet")}
      </Link>
    </div>
  );
};

export default SubscriptionCard;
